module.exports = "/assets/2e71cee435fcbe450d86b9d0e7f43f18.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/EN.png
// module id = 2468
// module chunks = 0